import coverDividas from './Entenda_suas_dividas/Cover-Dividas.png'
import coverGuia from './Guia_Completo_Equilibrio_Financeiro/Cover-Equilibrio-Financeiro.png'
import coverPortoBank from './Guia_Financeiro_Porto_Bank/Cover-Guia-PortoBank.png'

export default [
    {
        title: 'Guia financeiro PortoBank',
        id: 'guia_financeiro_portobank',
        imgUrl: coverPortoBank,
    },
    {
        title: 'Entenda suas dívidas',
        id: 'entenda_dividas',
        imgUrl: coverDividas,
    },
    {
        title: 'Guia completo para o Equilibrio Financeiro',
        id: 'guia_completo_equilibrio_financeiro',
        imgUrl: coverGuia,
    },
]
